import React from 'react'
import { Thumbs, FreeMode } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import { isVideo } from '../../../utils';
import CustomVideo from '../../../global/ui/CustomVideo';

const BottomThumbnailStrip = ({ setThumbsSwiper, filteredPhotos, activeIndex, mainSwiper }: any) => {
    const getName = (url: any) => {
        const fileName = new URL(url)?.pathname?.split("/")?.pop();
        return fileName
    }
    return (
        <div className="lg-thumbs-wrap">
            <Swiper
                modules={[FreeMode, Thumbs]}
                onSwiper={setThumbsSwiper}
                freeMode
                watchSlidesProgress
                slidesPerView="auto"
                spaceBetween={4}
                className="lg-thumbs-swiper"
            >
                {filteredPhotos.map((photo: any, i: any) => (
                    <SwiperSlide key={photo.id} className="lg-thumb-slide">
                        <div className={`lg-thumb${activeIndex === i ? ' lg-thumb--active' : ''}`}
                            onClick={() => mainSwiper?.slideTo(i)}
                        >
                            {isVideo(photo)
                                ?
                                <CustomVideo
                                    className="lg-thumb__img"
                                    src={photo?.image}
                                    controls={false}
                                />
                                :
                                <img
                                    src={photo?.image}
                                    alt={photo?.id}
                                    className="lg-thumb__img"
                                />
                            }
                            <div className="lg-thumb__overlay" />
                            <span className="lg-thumb__name">{getName(photo?.image)}</span>
                            {/* <button
                                className="lg-thumb__menu"
                                onClick={e => e.stopPropagation()}
                                aria-label="Options"
                            >
                                <img src='/assets/images/dots-vertical-rounded.svg' alt='more' />
                            </button> */}
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
        </div>
    )
}

export default BottomThumbnailStrip